import React from "react";
import logo from "./logo.svg";
import Layout, { CAPABILITIES_LOOKUP, TAB_LOOKUP } from "./Layout";
import image from "./images/virtual-coworkers.jpg";
import ArrowButton from "./ArrowButton";
import Lottie from "react-lottie";
// If there are images, use the converted json (index.js)
import animationData from "./lottie/storyboard9/data.json";
// If there are NO images, just load the json directly
// import animationData from "./lottie/storyboard7/data.json";
import "./Capabilities6RealTimeEmployeeGuidanceScreen.scss";
import { useTranslation } from "react-i18next";

import { t } from "i18next";

function Capabilities6RealTimeEmployeeGuidanceScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="capabilities-screen fill-absolute">
      <div className="container row">
        <div className="challenges-image padding flex lottie-container">
          <Lottie
            options={{
              animationData,
            }}
          />
        </div>
        <div className=" padding flex vertical-center">
          <div className="spacer" />
          <h2 className="green-header">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Capability6.title_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </h2>
          <p>{t("Capability6.section1")}</p>
          <p>{t("Capability6.section2")}</p>
          <p>{t("Capability6.section3")}</p>
          <div className="spacer" />
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton
          to="/capabilities-intelligent-routing"
          side="left"
        ></ArrowButton>
        <ArrowButton
          to="/capabilities-orchestrating-workflows"
          side="right"
        ></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities6RealTimeEmployeeGuidanceScreen;
